import { useMutation } from 'react-query';
import {
  getDefenseDeviceByIdAsync,
  synchronizeDevicesByLicenseAsync,
} from '../../index';

export const useGetDefenseDeviceById = () =>
  useMutation(getDefenseDeviceByIdAsync);

export const useMutationSynchronizeDevices = () =>
  useMutation(synchronizeDevicesByLicenseAsync);
